import {ROLES_MATRIX} from 'core/constants/roleMatrix';

import {UserPermission, UserRoles} from '../types';

export const findPermissions = (role?: UserRoles) => (role ? ROLES_MATRIX[role] : []);

export const hasAccess = (rolePermissions?: UserPermission[], required?: UserPermission[]) => {
    if (!rolePermissions?.length) return false;
    if (!required || required.length === 0) return true;
    return required.some((r) => rolePermissions.includes(r));
};
